
<template>
	<FormGroupBox title="Planes Tarifarios">
		<template #append-title>
			<b-button class="ml-2" size="sm" variant="success" @click="addRatePlan" v-if="$hasPermission('rates.add')">
					<md-icon icon="add"/> Crear
			</b-button>
		</template>
	
		<b-form-row class="mt-3">
			<b-form-group
				class="col-lg-3"
				label="Vigencia">
				<b-form-select 	v-model="filters.vigencyOption" size="sm">
					<b-form-select-option value="">Mostrar todos</b-form-select-option>
					<b-form-select-option value='onlyCurrentRates'>Solo vigentes</b-form-select-option>
					<b-form-select-option value='avoidExpired'>Solo vigentes y futuros</b-form-select-option>
				</b-form-select>
			</b-form-group>
			<b-form-group
				class="col-lg-3"
				label="Palabra Clave">
				<b-form-input v-model="filters.keyword" 	size="sm"></b-form-input>
			</b-form-group>

			<div class="mt-3 ml-2">
				<b-button @click="loadRatePlans" size="md">
					Buscar
				</b-button>
				<b-button 
					class="ml-2"
					@click="$bvModal.show('quote-modal')" 
					size="md" 
					variant="primary">
					Cotizar
				</b-button>
			</div>
		</b-form-row>
	
		<div >
			<!-- <div class="d-flex w-100 justify-content-end">
				<b-button variant="primary" @click="newPromotion">Nueva promoción</b-button>
			</div> -->
			<div class="w-100" v-if="$hasPermission('promotion.supplier.show')">
				
				<b-overlay :show="loading" class="mx-auto m-3"></b-overlay>
				<b-table
				class="mt-3"
				stacked="sm"
				responsive
				striped
				small
				hover
				bordered
				:fields="ratePlansColumns"
				:items="ratePlans"
				>
				<template v-slot:cell(startDate)="row">
					<div
					class="d-flex flex-column"
					:class="[
						isValidateDate(row.item.endDate) ? '' : 'text-danger',
					]"
					>
					<span class="u:text-size-2 text-muted m-0">
						{{
						row.item.startDate != null
							? formatDate(row.item.startDate, "DD/MM/YYYY")
							: "Pendiente"
						}}
					</span>
					</div>
				</template>
				<template v-slot:cell(endDate)="row">
					<div
					class="d-flex flex-column"
					:class="[
						isValidateDate(row.item.endDate) ? '' : 'text-danger',
					]"
					>
					<span class="u:text-size-2 text-muted m-0"
						><md-icon
						icon="info"
						:class="[
							row.item.endDate == null
							? ''
							: isValidateDate(row.item.endDate)
							? 'text-success'
							: 'text-danger',
						]"
						:content="
							row.item.endDate == null
							? 'Vecimiento no configurado'
							: isValidateDate(row.item.endDate)
							? 'Tarifa activa'
							: 'Tarifa expirado'
						"
						v-tippy="{ arrow: true, arrowType: 'round' }"
						/>
						{{
						row.item.endDate != null
							? formatDate(row.item.endDate, "DD/MM/YYYY")
							: "Pendiente"
						}}
					</span>
					</div>
				</template>
				<template #cell(bookingWindow)="row">
					<div
					class="d-flex flex-column"
					:class="[
						isValidateDate(row.item.endDate) ? '' : 'text-danger',
					]"
					>
						<span class="u:text-size-2 text-muted m-0">
							{{
							row.item.startDate != null
								? formatDate(row.item.startDate, "DD/MM/YYYY")
								: "Pendiente"
							}}
						</span>
					</div>

					<div
					class="d-flex flex-column"
					:class="[
						isValidateDate(row.item.endDate) ? '' : 'text-danger',
					]"
					>
					<span class="u:text-size-2 text-muted m-0"
						><md-icon
						icon="info"
						:class="[
							row.item.endDate == null
							? ''
							: isValidateDate(row.item.endDate)
							? 'text-success'
							: 'text-danger',
						]"
						:content="
							row.item.endDate == null
							? 'Vecimiento no configurado'
							: isValidateDate(row.item.endDate)
							? 'Tarifa activa'
							: 'Tarifa expirado'
						"
						v-tippy="{ arrow: true, arrowType: 'round' }"
						/>
						{{
						row.item.endDate != null
							? formatDate(row.item.endDate, "DD/MM/YYYY")
							: "Pendiente"
						}}
					</span>
					</div>
				</template>

				<template #cell(travelWindow)="row">
					<div v-if="row.item.travelWindowStartDate && row.item.travelWindowEndDate" class="text-nowrap">
						<md-icon icon="date_range" class="small-icon text-muted"></md-icon>
						<small>{{ formatDateEs(row.item.travelWindowStartDate) }}</small>
						<br>
						<small class="ml-3">{{ formatDateEs(row.item.travelWindowEndDate) }}</small>
					</div>
					<small v-else class="text-muted">-</small>
				</template>

				<template #cell(serviceTime)="row">
					<div v-if="row.item.serviceStartTime && row.item.serviceEndTime" class="text-nowrap">
						<md-icon icon="schedule" class="small-icon text-muted"></md-icon>
						<small>{{ formatTime(row.item.serviceStartTime) }}</small>
						-
						<small>{{ formatTime(row.item.serviceEndTime) }}</small>
					</div>
					<small v-else class="text-muted">-</small>
				</template>

				<template #cell(overlaps)="row">
					<div v-if="row.item.overlaps && row.item.overlaps.length > 0">
						<b-badge
							:variant="getOverlapBadgeVariant(row.item.overlaps)"
							class="overlap-badge"
							v-tippy="{
								arrow: true,
								arrowType: 'round',
								placement: 'right',
								interactive: true,
								maxWidth: 450
							}"
							:content="getOverlapTooltip(row.item.overlaps)"
						>
							<md-icon icon="warning" class="small-icon"></md-icon>
							{{ row.item.overlaps.length }}
						</b-badge>
					</div>
					<small v-else class="text-muted">-</small>
				</template>

				<template v-slot:cell(actions)="row">
					<div class="d-flex justify-content-between">
						<a
							:href="`/rate-plans-edit?id=${row.item.id}`"
							target="_blank"
							v-if="$hasPermission('prices.show') && false"
							class="btn btn-sm mr-1 btn-warning px-0"
							content="Edición de tarifa padre"
							v-tippy="{ arrow: true, arrowType: 'round' }"
						>
							<md-icon icon="attach_money" />
						</a>
						<b-button
							@click="(event) => viewRatePlan(row.item.id)"
							type="button"
							size="sm"
							class="mr-1"
							variant="primary"
							content="Edición de plan tarifario"
							v-tippy="{ arrow: true, arrowType: 'round' }"
						>
							<md-icon icon="edit" />
						</b-button>
						<b-button
							v-if="$hasPermission('rates.delete')"
							@click="
							(event) => deleteRatePlan(row.item, row.index, event)
							"
							type="button"
							size="sm"
							class="mr-1"
							variant="danger"
							content="Eliminar tarifa"
							v-tippy="{ arrow: true, arrowType: 'round' }"
						>
							<md-icon icon="delete" />
						</b-button>

						<b-dropdown
							v-if="$hasPermission('rates.expire')"
							id="dropdown-1"
							text="Dropdown Button"
							variant="success"
							size="sm"
							class="mr-1"
							content="Cierre de tarifa"
							v-tippy="{ arrow: true, arrowType: 'round' }"
						>
							<template #button-content
							><md-icon icon="price_check" />
							</template>
							<b-dropdown-item
							@click="showOpcionsDateRate(row.item, 'expire')"
							>Config. expiración de tarifa</b-dropdown-item
							>
							<b-dropdown-item
							@click="
								showOpcionsDateRate(row.item, 'expireAndDuplicate')
							"
							>Config. expiración y duplicar tarifa</b-dropdown-item
							>
						</b-dropdown>
					</div>
				</template>
				</b-table>
			</div>

			<div class="d-flex w-100" v-else>
				<h1>Sin permisos para visualizar datos</h1>
			</div>

			<RatePlanSingle
				:unableEdit="unableEditRatePlan"
				embbebedOnSupplier
				:supplierId="idSupplier"
				ref="ratePlanSingle"
				:success-callback="successCallbackRatePlan"
			/>
		</div>


			<!-- modal cierre de tarifa -->
			<b-modal
			hide-footer
			ref="refClosingRate"
			size="md"
			:title="
				TypeOfClousure == 'expire'
				? 'Config. expiración de tarifa'
				: 'Config. expiración y duplicar tarifa'
			"
		>
			<ClosingRateModal
				@closeModal="$refs['refClosingRate'].hide()"
				ref="refBodyCloseRate"
				:TypeOfClousure="TypeOfClousure"
				@refreshTableRate="loadRatePlans()"
			/>
		</b-modal>

		
	</FormGroupBox>

</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox";
import RatePlanSingle from "../../rate-plans/Single";

import ClosingRateModal from "../../rate-plans/ClosingRateModal.vue";
//import SingleForm from "./SingleForm.vue"
import moment from "moment";
export default {
	props:{
		idSupplier:{
			type: [String, Number],
			required: true
		}
	},
	components: {
		FormGroupBox,RatePlanSingle,ClosingRateModal
	},
	data(){
		return{
			loading:false,
			unableEditRatePlan: false,
			ratePlans:[],
			TypeOfClousure: "expire",
			ratePlansColumns: [
				{ key: "id", label: "Id" },
				{ key: "name", label: "Nombre" },
				{ key: "overlaps", label: "Solapamiento" },
				{ key: "zonedAreaName", label: "Area", sortable: true },
				{ key: "supplierZonedAreaName", label: "Area proveedor", sortable: true },
				{ key: "currency", label: "Moneda" },
				{ key: "heritance", label: "Conf. Herencia" },
				{ key: "rateType", label: "Tipo" },
				//{ key: "startDate", label: "F.Inicio", sortable: true },
				// //{ key: "endDate", label: "F.Vecimiento", sortable: true },
				{ key: 'bookingWindow',label:'Fecha de asignación', sortable: true},
				{ key:'travelWindow',label:'Fecha de viaje'},
				{ key:'serviceTime',label:'Horario Servicio'},
				{ key: "actions", label: "Acciones" },
			],
			filters:{
				vigencyOption:"onlyCurrentRates",
				keyword:""
			}
		}

	},
	mounted(){
		this.loadRatePlans();
	},
	methods:{
		loadRatePlans() {
			
			if (this.idSupplier > 0 && this.$hasPermission('rates.show')) {
				this.loading=true;
				this.$root.api
				.get(`/suppliers/${this.idSupplier}/rate-plans`,{params:{filters:this.filtersClean}})
				.then((res) => {
					this.ratePlans = res.data;
				})
				.catch(this.$root.handleRequestError)
				.finally(()=>{
					this.loading=false;
				})
			}
		},
		viewRatePlan(id) {
			this.unableEditRatePlan =  !this.$hasPermission("rates.edit");
			this.$refs["ratePlanSingle"].loadModel(id);
		},
		addRatePlan() {
			this.$refs["ratePlanSingle"].loadModel(-1);//this open the modal
			setTimeout(()=>{//little pause to give time to create in the browser
				this.$refs["ratePlanSingle"].setSupplierId(this.idSupplier);
			},100)
		},
		successCallbackRatePlan() {
			this.loadRatePlans();
		},
		deleteRatePlan(item) {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
				setLoading(true);
				this.$root.api
					.delete(`/rate-plans/${item.id}/suppliers/${this.idSupplier}`)
					.then(() => {
					this.$root.showAlert("Registro Eliminado!", {
						variant: "warning",
					});
					this.loadRatePlans();
					close();
					})
					.catch((err) => {
					this.$root.handleRequestError(err);
					close();
					});
				},
			});
		},
		isValidateDate(fecha) {
			//validamos que el campo sea distinto de null
			if (fecha != null) {
				//obtenemos la fecha actual
				let today = moment().format("YYYY-MM-DD h:mm:ss");
				return (
				moment(today).toDate() <= moment(fecha, "YYYY-MM-DD h:mm:ss").toDate()
				);
			}
			return false;
		},
		formatDate(date, format) {
			return moment(date).format(format);
		},
		isNotExpiredRate(fecha) {
			//validamos que el campo sea distinto de null
			if (fecha != null) {
				let today = moment(new Date().toDateString()).format(
				"YYYY-MM-DD h:mm:ss"
				);

				let fechaProcesada = moment(fecha).format('"YYYY-MM-DD h:mm:ss');
				console.log(
				moment(today).toDate() + "=" + moment(fechaProcesada).toDate()
				);
				console.log(moment(today).toDate() <= moment(fechaProcesada).toDate());
				return moment(today).toDate() <= moment(fechaProcesada).toDate();
			}
			return false;
		},
		showOpcionsDateRate(itemRate, status) {
			let me = this;
			this.$refs["refClosingRate"].show();
			setTimeout(function () {
				me.$refs.refBodyCloseRate.setTypeOfClousure(status);
				me.$refs.refBodyCloseRate.setRate(itemRate);
			}, 200);
		},
		formatDateEs(dateString) {
			if (!dateString) return '';
			if (dateString == 'Not set') return '';
			try {
				const date = new Date(dateString);
				const options = { year: 'numeric', month: 'short', day: '2-digit' };
				return date.toLocaleDateString('es-ES', options);
			} catch (error) {
				return dateString;
			}
		},
		formatTime(timeString) {
			if (!timeString) return '';
			try {
				const timeParts = timeString.split(':');
				if (timeParts.length >= 2) {
					return `${timeParts[0]}:${timeParts[1]}`;
				}
				return timeString;
			} catch (error) {
				return timeString;
			}
		},
		getOverlapTooltip(overlaps) {
			if (!overlaps || overlaps.length === 0) return '';

			let tooltip = '<div style="text-align: left; padding: 0.25rem;"><strong>Planes solapados:</strong><br>';
			overlaps.forEach((overlap, index) => {
				tooltip += `<br><strong>${index + 1}. [ID: ${overlap.ratePlanId}] ${overlap.ratePlanName}</strong><br>`;
				tooltip += `<small>- Solapamiento en: ${this.getOverlapTypesLabel(overlap.overlapTypes)}</small>`;
			});
			tooltip += '</div>';

			return tooltip;
		},
		getOverlapBadgeVariant(overlaps) {
			if (!overlaps || overlaps.length === 0) return 'warning';

			// Encontrar el número máximo de tipos de solapamiento en cualquier overlap
			let maxOverlapTypes = 0;
			overlaps.forEach(overlap => {
				if (overlap.overlapTypes && overlap.overlapTypes.length > maxOverlapTypes) {
					maxOverlapTypes = overlap.overlapTypes.length;
				}
			});

			// Determinar color basado en el número de tipos de solapamiento
			if (maxOverlapTypes >= 3) {
				return 'danger'; // Rojo para 3 o más tipos
			} else if (maxOverlapTypes === 2) {
				return 'warning'; // Amarillo para 2 tipos
			} else {
				return 'info'; // Azul para 1 tipo
			}
		},
		getOverlapTypesLabel(overlapTypes) {
			if (!overlapTypes || overlapTypes.length === 0) return '';

			const labels = overlapTypes.map(type => {
				switch(type.toLowerCase()) {
					case 'vigencia':
						return 'Vigencia';
					case 'ventana de viaje':
						return 'Ventana de viaje';
					case 'horario servicio':
						return 'Horario servicio';
					default:
						return type;
				}
			});

			return labels.join(', ');
		},
		getOverlapIcon(overlapTypes) {
			if (!overlapTypes || overlapTypes.length === 0) return 'info';

			// Determinar icono basado en el tipo de solapamiento
			if (overlapTypes.some(t => t.toLowerCase() === 'vigencia')) {
				return 'event';
			} else if (overlapTypes.some(t => t.toLowerCase() === 'ventana de viaje')) {
				return 'date_range';
			} else if (overlapTypes.some(t => t.toLowerCase() === 'horario servicio')) {
				return 'schedule';
			}

			return 'info';
		}
	},
	computed: {
		filtersClean(){
			return {
				vigencyOption:this.filters.vigencyOption,
				keyword:this.filters.keyword
			}
		}
    }
}
</script>

<style scoped>
.small-icon {
	font-size: 14px;
	vertical-align: middle;
}

.tiny-icon {
	font-size: 12px;
	vertical-align: middle;
}

.text-nowrap {
	white-space: nowrap;
}

/* Overlap indicator styles */
.overlap-badge {
	display: inline-flex;
	align-items: center;
	padding: 0.35rem 0.6rem;
	font-weight: 600;
	cursor: help;
	border-radius: 0.25rem;
	transition: all 0.2s ease;
}

.overlap-badge:hover {
	transform: scale(1.05);
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.overlap-badge .small-icon {
	font-size: 14px;
	margin-right: 0.25rem;
}

.overlap-details {
	max-width: 200px;
}

.overlap-details small {
	font-size: 0.75rem;
	line-height: 1.6;
	color: #6c757d;
	display: flex;
	align-items: center;
}

/* lg */
@media screen and (min-width: 1000px) {
	.modal-dialog{
		width: 55%!important;
		max-width: 55%!important;
	}
}
/* md */
@media screen and (min-width: 720px) and (max-width: 899px)  {
	.modal-dialog{
		width: 75%!important;
		max-width: 75%!important;
	}
}
/* sm */
@media screen and (max-width: 719px) {
	.modal-dialog{
		width: 95%!important;
		max-width: 95%!important;
	}
}
</style>
